/* Partnership - BI */
import { FEATURES } from '@constants/Text'
import * as partnershipStore from './store'

export const PERMISSION = FEATURES.PARTNERSHIP
export const PERMISSION_DATA_ROOM = FEATURES.PARTNERSHIP_DATA_ROOM

export function partnershipModule({ store }) {
  store.registerModule('partnership', { ...partnershipStore, namespaced: true })
}
